import { Theme, createStyles, StyleRules } from '@material-ui/core'

export function styleCreate<T extends string>(creator: (theme: Theme) => StyleRules<T, any>) {
  return (theme: Theme) => createStyles<T, any>(creator(theme))
}